import { render, staticRenderFns } from "./selectTree.vue?vue&type=template&id=535a656c&scoped=true"
import script from "./selectTree.vue?vue&type=script&lang=js"
export * from "./selectTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535a656c",
  null
  
)

export default component.exports